import React, { useState, useEffect } from "react";
import { Beat } from "../../../redux/reducers/spinner";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../../redux/actions";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import Location from "../../includes/Location";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { removePlusSign } from "../../helper/phoneNumber";

function EditAddress({ addressData }) {
  const id = addressData?.id;
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // Update the document title using the browser API
    setAddressPhone(addressData?.phone);
  }, [addressData]);

  //This is used to get the list of region data ie: country, city and states
  const [locationId, setLocationId] = React.useState({
    country_id: "",
    state_id: "",
    city_id: "",
  });
  const [locationList, setLocationList] = React.useState({
    countryList: [],
    stateList: [],
    cityList: [],
  });
  const toJson = (value) => JSON.stringify(value);
  const fromJson = (value) => JSON.parse(value);

  const [submitted, setSubmitted] = useState(false);
  let [phone, setAddressPhone] = useState("");
  phone = removePlusSign(phone);
  const [data, setData] = useState({
    id: addressData?.id,
    email: addressData?.email,
    name: addressData?.name,
    title: addressData?.title,
    phone: addressData?.phone,
    address: addressData?.address,
    city: addressData?.city,
    state: addressData?.state,
    country: addressData?.country,
  });

  useEffect(() => {
    if (addressData) {
      setData((prev) => ({
        ...prev,
        id: addressData?.id,
        email: addressData?.email,
        name: addressData?.name,
        title: addressData?.title,
        phone: addressData?.phone,
        address: addressData?.address,
        city: addressData?.city,
        state: addressData?.state,
        country: addressData?.country,
      }));
    }
  }, [addressData]);
  const { email, name, title, address, city, state, country } = data;

  const updating = useSelector((state) => state.admin.updating);
  const handleChange = (event) => {
    const { name, value } = event.target;
    setData((data) => ({ ...data, [name]: value }));
  };
  function handleRegion(e) {
    const { name, value } = e.target;
    setData((data) => ({ ...data, [name]: fromJson(value).name }));
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitted(true);
    // dispatch action to create data
    try {
      const response = await dispatch(
        userActions.editAddress({ ...data, phone, id: id })
      );
      if (response) {
        dispatch(userActions.getSingleAddress(id));
      }
    } catch (error) {}

    handleClose();
  };

  return (
    <div>
      <MDBContainer>
        <MDBBtn onClick={() => setOpen(true)} title="Edit Address">
          <span className="mr-2">Edit Address</span>
          <i className="nav-icon i-Pen-2" />
        </MDBBtn>
        <MDBModal isOpen={open} toggle={handleClose}>
          <form name="form" onSubmit={handleSubmit}>
            <MDBModalHeader toggle={handleClose}>Edit Address</MDBModalHeader>
            <MDBModalBody>
              <div className="text-left row pt-4">
                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && title ? " has-error" : "")
                  }
                >
                  <label htmlFor="title">Address title*</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={data.title}
                    name="title"
                    onChange={handleChange}
                  />
                  {submitted && title && (
                    <div className="invalid-feedback">
                      Address title is required
                    </div>
                  )}
                </div>
                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && name ? " has-error" : "")
                  }
                >
                  <label htmlFor="name">Address name*</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={data.name}
                    name="name"
                    onChange={handleChange}
                  />
                  {submitted && name && (
                    <div className="invalid-feedback">
                      Address name is required
                    </div>
                  )}
                </div>
                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && email ? " has-error" : "")
                  }
                >
                  <label htmlFor="email">Address email*</label>
                  <input
                    type="email"
                    className="form-control"
                    defaultValue={data.email}
                    name="email"
                    onChange={handleChange}
                  />
                  {submitted && email && (
                    <div className="invalid-feedback">
                      Address email is required
                    </div>
                  )}
                </div>
                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && phone ? " has-error" : "")
                  }
                >
                  <label htmlFor="phone">Address phone*</label>
                  <PhoneInput
                    className="form-control"
                    value={data.phone}
                    onChange={setAddressPhone}
                    defaultCountry="NG"
                  />
                  {submitted && phone && (
                    <div className="invalid-feedback">
                      Address phone is required
                    </div>
                  )}
                </div>

                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && address ? " has-error" : "")
                  }
                >
                  <label htmlFor="address">Address address*</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={data.address}
                    name="address"
                    onChange={handleChange}
                  />
                  {submitted && address && (
                    <div className="invalid-feedback">
                      Address address is required.
                    </div>
                  )}
                </div>

                {/* Here, we utilize the location component to get the location data */}
                <Location
                  country_id={locationId.country_id}
                  state_id={locationId.state_id}
                  city_id={locationId.city_id}
                  countryList={(value) => {
                    setLocationList({ ...locationList, countryList: value });
                  }}
                  stateList={(value) => {
                    setLocationList({ ...locationList, stateList: value });
                  }}
                  cityList={(value) => {
                    setLocationList({ ...locationList, cityList: value });
                  }}
                  country_name={data.country}
                  state_name={data.state}
                  city_name={data.city}
                />
                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && country ? " has-error" : "")
                  }
                >
                  <label htmlFor="country">Address country*</label>
                  <select
                    name="country"
                    selected={data.country}
                    className="form-control"
                    onChange={(e) => {
                      setLocationId({
                        ...locationId,
                        country_id: fromJson(e.target.value).id,
                      });
                      handleRegion(e);
                    }}
                  >
                    {data.country && (
                      <option value={data.country}>{data.country}</option>
                    )}
                    {locationList.countryList &&
                      locationList.countryList.length > 0 &&
                      locationList.countryList.map((item, key) => {
                        return (
                          <option
                            key={key}
                            value={toJson({ name: item.name, id: item.id })}
                          >
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                  {submitted && country && (
                    <div className="invalid-feedback">
                      Address country is required
                    </div>
                  )}
                </div>
                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && state ? " has-error" : "")
                  }
                >
                  <label htmlFor="state">Address state</label>
                  <select
                    name="state"
                    selected={data.state}
                    className="form-control"
                    onChange={(e) => {
                      setLocationId({
                        ...locationId,
                        state_id: fromJson(e.target.value).id,
                      });
                      handleRegion(e);
                    }}
                  >
                    {data.state && (
                      <option value={data.state}>{data.state}</option>
                    )}
                    {locationList.stateList &&
                      locationList.stateList.length > 0 &&
                      locationList.stateList.map((item, key) => {
                        return (
                          <option
                            key={key}
                            value={toJson({ name: item.name, id: item.id })}
                          >
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                  {submitted && state && (
                    <div className="invalid-feedback">
                      Address state is required.
                    </div>
                  )}
                </div>
                <div
                  className={
                    "form-group col-md-12 mb-4" +
                    (submitted && city ? " has-error" : "")
                  }
                >
                  <label htmlFor="city">Address city*</label>
                  <select
                    name="city"
                    selected={data.city}
                    className="form-control"
                    onChange={(e) => {
                      setLocationId({
                        ...locationId,
                        city_id: fromJson(e.target.value).id,
                      });
                      handleRegion(e);
                    }}
                  >
                    {data.city && (
                      <option value={data.city}>{data.city}</option>
                    )}
                    {locationList.cityList &&
                      locationList.cityList.length > 0 &&
                      locationList.cityList.map((item, key) => {
                        return (
                          <option
                            key={key}
                            value={toJson({ name: item.name, id: item.id })}
                          >
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                  {submitted && city && (
                    <div className="invalid-feedback">
                      Address city is required
                    </div>
                  )}
                </div>
              </div>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color="secondary" onClick={() => setOpen(false)}>
                Close
              </MDBBtn>
              <MDBBtn color="primary" type="submit">
                {updating === true ? (
                  <Beat loading={updating} />
                ) : (
                  "Edit Address"
                )}
              </MDBBtn>
            </MDBModalFooter>
          </form>
        </MDBModal>
      </MDBContainer>
    </div>
  );
}

export default EditAddress;
